// Links from ThetaLabs (JEE Advanced) to SolveIT (solveit.page) for the other exams.
// Every URL here is a live solveit.page page, checked against solveit.page/sitemap.xml;
// a topic without a clear JEE Main chapter links to the JEE Main Maths hub, never a guess.

export const SOLVEIT = 'https://solveit.page';

export const SOLVEIT_JEE_MAIN_MATHS = { href: `${SOLVEIT}/jee-main/mathematics`, name: 'JEE Main Maths' };

export const SOLVEIT_EXAMS = [
  { href: `${SOLVEIT}/jee-main`,    name: 'JEE Main' },
  { href: `${SOLVEIT}/neet`,        name: 'NEET' },
  { href: `${SOLVEIT}/cbse-papers`, name: 'CBSE Class 10 & 12' },
];

// ThetaLabs topic slug (from Notion) → SolveIT JEE Main Maths chapter.
const JEE_MAIN_CHAPTER = {
  'binomial-theorem':                  ['binomial-theorem', 'Binomial Theorem'],
  'complex-numbers':                   ['complex-numbers', 'Complex Numbers'],
  'determinants':                      ['matrices-and-determinants', 'Matrices and Determinants'],
  'matrix':                            ['matrices-and-determinants', 'Matrices and Determinants'],
  'functions':                         ['relations-and-functions', 'Relations and Functions'],
  'inverse-trigonometric-functions':   ['inverse-trigonometric-functions', 'Inverse Trigonometric Functions'],
  'permutations-and-combinations':     ['permutations-and-combinations', 'Permutations and Combinations'],
  'probability':                       ['probability', 'Probability'],
  'quadratic-equations':               ['quadratic-equations', 'Quadratic Equations'],
  'sequences-and-series':              ['progressions', 'Sequences and Progressions'],
  'set-theory':                        ['sets', 'Sets'],
  'statistics':                        ['statistics', 'Statistics'],
  'three-dimension-geometry':          ['3d-geometry', '3D Geometry'],
  'vectors':                           ['vectors', 'Vectors'],
  'application-of-derivatives':        ['applications-of-derivatives', 'Applications of Derivatives'],
  'area-under-the-curve':              ['area-under-the-curve', 'Area Under the Curve'],
  'continuity-and-differentiabililty': ['continuity-and-differentiability', 'Continuity and Differentiability'],
  'definite-integration':              ['definite-integration', 'Definite Integration'],
  'differential-equations':            ['differential-equations', 'Differential Equations'],
  'differentiation':                   ['methods-of-differentiation', 'Methods of Differentiation'],
  'indefinite-integration':            ['indefinite-integration', 'Indefinite Integration'],
  'limits':                            ['limits', 'Limits'],
  'circle':                            ['circle', 'Circle'],
  'ellipse':                           ['ellipse', 'Ellipse'],
  'hyperbola':                         ['hyperbola', 'Hyperbola'],
  'parabola':                          ['parabola', 'Parabola'],
  'straight-line':                     ['straight-lines', 'Straight Lines'],
  'properties-of-triangle':            ['properties-of-triangle', 'Properties of Triangle'],
  'trigonometric-indenties':           ['trigonometric-identities', 'Trigonometric Identities'],
  'trigonometric-equations':           ['trigonometric-equations', 'Trigonometric Equations'],
};

/** The SolveIT JEE Main page for a ThetaLabs topic: { href, name }. */
export function solveitForTopic(topicSlug) {
  const hit = JEE_MAIN_CHAPTER[topicSlug];
  return hit ? { href: `${SOLVEIT}/jee-main/mathematics/${hit[0]}`, name: hit[1] } : SOLVEIT_JEE_MAIN_MATHS;
}
